import { slideDown, slideUp } from '@theme/utilities';

const getBannerStorage = (): string[] => {
	const storageItem = sessionStorage.getItem(sessionStorageKey);
	if (storageItem === null) return [];

	try {
		const data: unknown = JSON.parse(storageItem);
		return Array.isArray(data) && data.every((item) => typeof item === 'string') ? data : [];
	} catch {
		return [];
	}
};

const setBannerStorage = (data: string[]) => sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));

const selectors = {
	banner: '.banner',
	bannerClose: '.banner__close',
};

const sessionStorageKey = 'mcfly_hidden_banners';
const hiddenBanners = getBannerStorage();
const slideDuration = 250;

window.addEventListener('load', () => {
	document.querySelectorAll(selectors.banner).forEach((banner) => {
		// Show banner if banner has not been closed a previous time
		if (!hiddenBanners.includes(banner.id)) {
			slideDown(banner, slideDuration);
		}
	});
});

// Close banner on click
document.querySelectorAll(selectors.bannerClose).forEach((close) => {
	close.addEventListener('click', () => {
		// Close banner
		const banner = close.closest(selectors.banner);
		if (!banner) return;
		slideUp(banner, slideDuration);

		// Update storage
		const hiddenBanners = getBannerStorage();
		hiddenBanners.push(banner.id);
		setBannerStorage(hiddenBanners);
	});
});
